<template>
    <div
        id="login-page"
        :style="borderStyle"
    >
        <div class="login-content">
            <div class="title">{{ appName }}</div>

            <div class="field">
                <label>{{ trans('pages.login.user') }}</label>
                <text-input
                    :placeholder="trans('pages.login.user_placeholder')"
                    v-model="employee"
                />
            </div>

            <div class="field">
                <label>{{ trans('pages.login.pin_code') }}</label>
                <text-input
                    type="password"
                    :placeholder="trans('pages.login.pin_code_placeholder')"
                    v-model="password"
                    @enter="executeLogin()"
                />
            </div>

            <numpad v-model="password" />

            <div class="bottom-row">
                <div class="version">{{ version }}</div>
                <div
                    class="crm-button"
                    @click="executeLogin()"
                >
                    {{ trans('pages.login.login_button') }}
                    <img
                        class="icon"
                        src="images/icons/arrow-left.svg"
                    />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import api from '../api/user.js';
import Numpad from '../components/Numpad';
import TextInput from '../components/TextInput';
import AutoCompleteInput from '../components/AutoCompleteInput';
import isDebugMixin from '../mixins/is-debug';
import Tikklok from '../shared/Tikklok';
import { loadPage } from '../helpers/NavigationHelper';
import { showErrorMessage } from '../dialogs';
import localization from '../mixins/localization';

export default {
    mixins: [isDebugMixin, localization],
    computed: {
        appName: () => Config.appName,
        version: () => Config.version,
        borderStyle() {
            const configColor = Config.backgroundcolor.toString();

            return {
                'border-top-color':
                    configColor && configColor.length ? configColor : '#DFA11A',
            };
        },
    },
    data() {
        return {
            password: '',
            employee: '',
        };
    },
    methods: {
        executeLogin() {
            const login = this.employee;
            const password = this.password;

            if (!login || !password) {
                return showErrorMessage(
                    this.trans('pages.login.enter_credentials')
                );
            }

            this.authenticate(login, password);
        },
        authenticate(login, password) {
            const authERP = api
                .validateLogin(login, password)
                .then((response) => {
                    window.localStorage.removeItem('vuexPermanent');

                    const user = response.data.data;

                    this.$store.commit(
                        'currentUser/setSessionKey',
                        { key: user.session_key, environment: 'ERP' },
                        { root: true }
                    );
                });

            const authAPI = api
                .validateApiLogin(login, password)
                .then((response) => {
                    const token = response.data.token;
                    const refreshToken = response.data.refreshToken;
                    const tokenExpiresAt = response.data.tokenExpiresAt;
                    const refreshTokenExpiresAt =
                        response.data.refreshTokenExpiresAt;

                    this.$store.commit('currentUser/setApiCredentials', {
                        token: {
                            key: token,
                            expiresAt: tokenExpiresAt,
                        },
                        refreshToken: {
                            key: refreshToken,
                            expiresAt: refreshTokenExpiresAt,
                        },
                    });

                    this.$store.commit(
                        'currentUser/setSessionKey',
                        { key: token, environment: 'API' },
                        { root: true }
                    );

                    this.$store.commit(
                        'currentUser/setSessionKey',
                        { key: refreshToken, environment: 'API-refresh' },
                        { root: true }
                    );

                    this.$store.commit(
                        'currentUser/setApiCredentials',
                        {
                            token: {
                                value: token,
                                expiresAt: tokenExpiresAt,
                            },
                            refreshToken: {
                                value: refreshToken,
                                expiresAt: refreshTokenExpiresAt,
                            },
                        },
                        { root: true }
                    );
                });

            Promise.all([authERP, authAPI])
                .then(() => {
                    api.fetchCurrentEmployeeDetails().then((response) => {
                        const details = response.data.data;

                        this.$store.commit(
                            'currentUser/setName',
                            details.name,
                            {
                                root: true,
                            }
                        );
                        this.$store.commit(
                            'currentUser/setUserName',
                            details.employee_name,
                            { root: true }
                        );
                        this.$store.commit(
                            'currentUser/setUserId',
                            details.ID,
                            {
                                root: true,
                            }
                        );
                        this.$store.commit(
                            'currentUser/setUserLocation',
                            details.location || null,
                            { root: true }
                        );
                        if (details.location) {
                            this.$store.commit(
                                'currentUser/setUserLocationDateCurrent',
                                undefined,
                                { root: true }
                            );
                        } else {
                            this.$store.commit(
                                'currentUser/setUserLocationDate',
                                null,
                                { root: true }
                            );
                        }
                        this.$store.commit(
                            'currentUser/setRights',
                            details.rights,
                            { root: true }
                        );

                        Tikklok.initTikklok();
                        const url = this.$route.query.url || 'menu';
                        loadPage(url);
                    });
                })
                .catch((error) => {
                    const response = error.response;
                    const details = response.data.data;

                    if (details && details.error_code === 'login_blocked') {
                        return showErrorMessage(
                            this.trans('pages.login.blocked')
                        );
                    }

                    if (details && details.error_code === 'login_attempts') {
                        return showErrorMessage(
                            this.trans(
                                'pages.login.incorrect_credentials_with_attempts',
                                {
                                    attempts: details.attempts,
                                }
                            )
                        );
                    }

                    showErrorMessage(
                        this.trans('pages.login.incorrect_credentials')
                    );
                });
        },
    },
    components: {
        Numpad,
        TextInput,
        AutoCompleteInput,
    },
};
</script>
